import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment/moment';
import { toast } from 'react-toastify';
import { FormControlLabel, Radio, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { CreateChancel, DateTypeSelect, NotError } from 'components';
import { useModal } from 'utils';
import { CsvService } from 'store';

const sessionCsvType = {
    OVERVIEW: 'OVERVIEW',
    DETAIL: 'DETAIL',
};

export const DownloadSessionCsv = ({}) => {
    const [error, setError] = useState({});
    const [inputs, setInputs] = useState({});
    const [load, setLoad] = useState(false);
    const { close } = useModal();
    const client = useSelector((state) => state.client.clientItemInfo);

    useEffect(() => {
        const params = {
            startDate: moment().subtract(6, 'months').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            type: sessionCsvType.OVERVIEW,
        };
        setInputs(params);
    }, []);

    const handleChange = (e) => {
        setInputs((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
        setError((prev) => {
            const next = { ...prev };

            if (inputs?.startDate) next.startDate = null;
            if (inputs?.endDate) next.endDate = null;

            return next;
        });
    };

    const handleExport = async () => {
        setLoad(true);

        const params = { ...inputs, clientId: client.id };
        const nextError = {};
        if (!params.startDate) nextError.startDate = 'Start Date is required';
        if (!params.endDate) nextError.endDate = 'End Date is required';

        if (Object.keys(nextError).length) {
            setError((prev) => ({ ...prev, ...nextError }));
        } else {
            try {
                await CsvService.sessionDataCsv(params);
                toast(<NotError errMessage="The CSV has been successfully added to the generation queue." />);
                close();
            } catch (e) {
                toast(<NotError type="error" errMessage="Failed to generate the CSV." />);
            }
        }
        setLoad(false);
    };

    const sessionDownloadType = [
        {
            type: sessionCsvType.OVERVIEW,
            description: 'Exports Goals + Targets session summary (no trial details)',
            name: 'Summary CSV ',
        },
        {
            type: sessionCsvType.DETAIL,
            description: 'Exports full Goals/Targets data including every trial record',
            name: 'Detailed CSV',
        },
    ];

    return (
        <div className="download-payroll-csv-modal">
            <p className="download-modal-title">Download Goals CSV</p>
            <p className="download-modal-desc">Select the date range and export type for your Goals data</p>
            <div className="download-modal-body">
                <div className="start-end-time-box">
                    <DateTypeSelect
                        type={'modalInput'}
                        name={'startDate'}
                        error={error['startDate']}
                        outLabel={'Start Date*'}
                        handleGetDates={handleChange}
                        values={inputs}
                        max={inputs.endDate ? moment.utc(inputs.endDate).format('YYYY-MM-DD') : ''}
                    />
                    <DateTypeSelect
                        type={'modalInput'}
                        name={'endDate'}
                        outLabel={'End Date*'}
                        error={error['endDate']}
                        handleGetDates={handleChange}
                        values={inputs}
                        min={inputs.startDate ? moment.utc(inputs.startDate).format('YYYY-MM-DD') : ''}
                    />
                </div>
                <div className="download-session-data-modal-body">
                    {sessionDownloadType?.map((i, j) => (
                        <div
                            key={j}
                            className={inputs?.type === i.type ? 'form-type-box-active' : 'form-type-box-passive'}
                            style={{ marginBottom: '12px' }}
                        >
                            <FormControlLabel
                                onChange={handleChange}
                                name={'type'}
                                value={i.type}
                                label={
                                    <Box>
                                        <Typography variant="body1">{i.name}</Typography>
                                        <Typography variant="body2" color="textSecondary">
                                            {i.description}
                                        </Typography>
                                    </Box>
                                }
                                control={
                                    <Radio
                                        style={{ color: inputs?.type === i.type ? '#347AF0' : '#D0D5DD' }}
                                        checked={inputs?.type === i.type}
                                    />
                                }
                            />
                        </div>
                    ))}
                </div>
            </div>

            <div>
                <CreateChancel
                    loader={load}
                    create={'Download CSV'}
                    chancel={'Cancel'}
                    onCreate={handleExport}
                    onClose={() => close()}
                    buttonWidth="300px"
                />
            </div>
        </div>
    );
};
